module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_dir-35bba54fe0b2846b91ea56255dce9c1d.png";